import React, { Component } from 'react'
import XLSX from 'xlsx';
import { make_cols } from './MakeColumns';
import SheetJSFT from './Excel_type';
import Firebase from '../Firebase';

export class Import_data extends Component {
    constructor(props) {
        super(props);
        this.state = {
            file: {},
            data: [],
            cols: [],
            Tb_name: '',
        }
        this.handleFile = this.handleFile.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }


    handleChange(e) {
        const files = e.target.files;
        if (files && files[0]) this.setState({ file: files[0] });
    };
    onChange = (e) => {
        const state = this.state
        state[e.target.name] = e.target.value;
        this.setState(state);

    }
    handleFile() {
        /* Boilerplate to set up FileReader */

        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;
        const temp_date = [];
        reader.onload = (e) => {
            /* Parse data */
            const bstr = e.target.result;
            const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA: true });
            /* Get first worksheet */
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            /* Convert array of arrays */
            const data = XLSX.utils.sheet_to_json(ws);
            /* Update state */
            this.setState({ data: data, cols: make_cols(ws['!ref']) });

            console.log(this.state.data)

            const tb = Firebase.firestore().collection('SCHOOLS');

            this.state.data.forEach((element, i) => {
                temp_date.push({
                    School_ID: element.SchoolID,
                    School_name: element.SchoolName,
                    SubDistrict: element.SubDistrict,
                    District: element.District,
                    Province: element.Province,
                    PostCode: element.PostCode,
                    School_type: element.SchoolType,
                    Department: element.Department,
                    Website: element.Website,
                    Email: element.Email,
                    Latitude: element.Latitude,
                    Longitude: element.Longitude,
                })
                // tb.doc(element.SchoolID + "").set({
                //     School_name: element.SchoolName,
                //     SubDistrict: element.SubDistrict,
                //     District: element.District,
                //     Province: element.Province,
                //     PostCode: element.PostCode,
                //     School_type: element.SchoolType,
                //     Department: element.Department,
                //     Website: element.Website,
                //     Email: element.Email,
                //     Latitude: element.Latitude,
                //     Longitude: element.Longitude,
                // }).then((doc) => {
                //     console.log('import success');
                // }).catch((error) => {
                //     console.log('error', i)
                // })
            });





        };

        if (rABS) {
            reader.readAsBinaryString(this.state.file);
        } else {
            reader.readAsArrayBuffer(this.state.file);
        };
    }
    render() {
        return (
            <div>
                <input type="file" className="form-control" id="file" accept={SheetJSFT} onChange={this.handleChange} />
                <button type="submit" className='btn btn-success' onClick={this.handleFile}>import</button>
            </div>
        )
    }
}

export default Import_data
